export default "__VITE_ASSET__lm87sqrJ__"